import {
  COLOR_GRAY_4,
  COLOR_NEUTRAL,
  COLOR_NEUTRAL_DARK,
  COLOR_NEUTRAL_DARKEST,
  COLOR_NEUTRAL_LIGHT,
  COLOR_NEUTRAL_MID,
  COLOR_NEUTRAL_ULTRALIGHT,
  COLOR_PRIMARY,
  COLOR_RED,
  COLOR_TEXT_GRAY,
  COLOR_WH,
} from '../colors.constants';

export const colorsTextField = {
  // Textfield color
  colorTextFieldBorder: COLOR_NEUTRAL_LIGHT,
  colorTextFieldBorderHover: COLOR_NEUTRAL_LIGHT,
  colorTextFieldBorderFocused: COLOR_PRIMARY,
  colorTextFieldBackground: COLOR_NEUTRAL_ULTRALIGHT,
  colorTextFieldBackgroundHover: COLOR_WH,
  colorTextFieldColor: COLOR_NEUTRAL_DARK,
  colorTextFieldColorDisabled: COLOR_TEXT_GRAY,
  colorTextFieldColorError: COLOR_RED,
  colorTextFieldFormLabel: COLOR_NEUTRAL,
  colorsTextFieldFormLabelActive: COLOR_GRAY_4,
  colorTextFieldToken: COLOR_NEUTRAL_DARKEST,
  colorTextFieldTokenLabel: COLOR_NEUTRAL_MID,
  colorTextFieldTokenCaret: COLOR_PRIMARY,
  colorTextFieldTokenBackground: COLOR_NEUTRAL_DARKEST,
};
